'use strict';

import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import bemit from 'Functions/bemit';
export default function Radios(props) {
  const elements = (props.options || []).map(function (option) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      value: option.value,
      control: /*#__PURE__*/React.createElement(Radio, null),
      label: option.label,
      className: "c-radio-group__element",
      key: option.value
    });
  });
  const error_msg = props.status?.[props.name]?.error;
  return /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": props.label,
    name: props.name,
    value: props.value,
    onChange: handleChange,
    className: bemit('c-radio-group', props.bemit)
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-radio-group__label"
  }, props.label), elements, props.children);
  function handleChange(e) {
    const {
      value,
      name
    } = e?.target || {};
    props.onChange({
      e,
      name,
      value
    });
  }
}
